import { localStorage, sessionStorage } from "../state/utils/storage";
import useBrowserMode from "../hooks/useBrowserMode";


const { isBrowser } = useBrowserMode();
const USER_DATA = "userData";
const TOKEN_DATA = "tokenData";
const MIGRATION_DATA = "migrationData";
const USER_NAME = "userName";
const SAMPLES = "samples";

const findStorage = ( key ) => {
   return isBrowser && (localStorage.getItem(key) || sessionStorage.getItem(key) );
};

const getUserData = () => {
    return findStorage(USER_DATA);
};

const getMigrationData = () => {
    return findStorage(MIGRATION_DATA);
};


const getTokenData = () => {
    return findStorage(TOKEN_DATA);
};

const getIdTokenData = () => {
    const token = getTokenData();
    return token && token.idToken;
};

const getRefreshTokenData = () => {
    const token = getTokenData();
    return token && token.refreshToken;
};

const getUserName = () => {
    return findStorage(USER_NAME);
};
const getUserPoints = () => {
    const data = getUserData();
    return data && data.points;
};

const haveMainDirection = () => {
    const userData =  getUserData();
    return userData && userData.mainCity && userData.mainAddress;
};

const haveSecondDirection = () => {
    const userData =  getUserData();
    return userData && userData.secondCity && userData.secondAddress;
};

const isMigrationUser = () => {
    const migrationData =  getMigrationData();
    return migrationData && migrationData.organizationType === null;
};

const getSamples = () => {
    return findStorage(SAMPLES);
};

const SessionService = {
    getUserData,
    getMigrationData,
    getTokenData,
    getIdTokenData,
    getRefreshTokenData,
    getUserPoints,
    getUserName,
    haveMainDirection,
    haveSecondDirection,
    isMigrationUser,
    getSamples
};

export default SessionService;